import React from "react";
import TaskRunner from "../../components/TaskRunner/TaskRunner";
import {
  generateTasks,
  renderTask,
  renderInput,
  renderAnswer,
  renderExplanation,
  checkAnswer
} from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna";

export default function Lesson2_Tasks({ hideUtilityFabs = false } = {}) {
  return (
    <TaskRunner
      sectionTitle="Zadania: Ogólna (funkcja kwadratowa)"
      generateTasks={generateTasks}
      renderTask={renderTask}
      renderInput={renderInput}
      renderAnswer={renderAnswer}
      renderExplanation={renderExplanation}
      checkAnswer={checkAnswer}
      hideUtilityFabs={hideUtilityFabs}
    />
  );
}
